module.exports = __webpack_public_path__ + "static/media/grip.85d158e9.svg";